module.exports = __webpack_public_path__ + "static/img/60-3.0e6732c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/60-3.jpg
// module id = WwYv
// module chunks = 0